module.exports = __webpack_public_path__ + "static_portal/img/mild_style_boat.d3246262.webp";